import {Action} from 'redux'
import {HeadHuntApplicationModel} from '../Model'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const initialHeadHuntState: IHeadHuntState = {
  data: {
    applications: [],
    meta: {},
  },
  deleteSuccess: false,
  loading: false,
  success: false,
  exportSuccess: false,
  applicationDetail: undefined,
  applicationLoading: false,
}

export interface IHeadHuntState {
  data?: {
    applications?: HeadHuntApplicationModel[]
    meta?: {[key: string]: number}
  }
  deleteSuccess?: boolean
  loading?: boolean
  success?: boolean
  exportSuccess?: boolean
  applicationDetail?: any
  applicationLoading?: boolean
}

export const reducer = (
  state: IHeadHuntState = initialHeadHuntState,
  action: ActionWithPayload<IHeadHuntState>
) => {
  switch (action.type) {
    //GET head hunt applications
    case actionTypes.GET_HEAD_HUNT_APPLICATIONS_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_HEAD_HUNT_APPLICATIONS_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_HEAD_HUNT_APPLICATIONS_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Update head hunt application (status transition)
    case actionTypes.UPDATE_HEAD_HUNT_APPLICATIONS_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_HEAD_HUNT_APPLICATIONS_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_HEAD_HUNT_APPLICATIONS_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.UPDATE_HEAD_HUNT_APPLICATIONS_RESET: {
      return {
        ...state,
        success: false,
      }
    }

    //Delete
    case actionTypes.DELETE_HEAD_HUNT_APPLICATIONS_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_HEAD_HUNT_APPLICATIONS_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_HEAD_HUNT_APPLICATIONS_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Export csv
    case actionTypes.GET_HEAD_HUNT_APPLICATIONS_FILE_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_HEAD_HUNT_APPLICATIONS_FILE_SUCCESS: {
      return {
        ...state,
        exportSuccess: true,
        loading: false,
      }
    }

    case actionTypes.GET_HEAD_HUNT_APPLICATIONS_FILE_FINISH: {
      return {
        ...state,
        loading: false,
        exportSuccess: false,
      }
    }

    //Get single application detail (view-details modal)
    case actionTypes.GET_HEAD_HUNT_APPLICATION_START: {
      return {...state, applicationLoading: true}
    }

    case actionTypes.GET_HEAD_HUNT_APPLICATION_SUCCESS: {
      return {
        ...state,
        applicationDetail: action.payload,
        applicationLoading: false,
      }
    }

    case actionTypes.GET_HEAD_HUNT_APPLICATION_FINISH: {
      return {...state, applicationLoading: false}
    }

    case actionTypes.GET_HEAD_HUNT_APPLICATION_RESET: {
      return {...state, applicationDetail: undefined}
    }

    default:
      return state
  }
}
